import { DRNUtil } from '@traveloka/district-util';
import R from '../../../core-res/R';
//Horizontal breadcrumb const
export const HORIZONTAL_LINE_LENGTH = 24;
export const ITEM_MAX_LENGTH = DRNUtil.getScreenWidth() - 2 * R.spacing.s;
export const MOBILE_ITEM_MIN_LENGTH = ITEM_MAX_LENGTH / 3;
export const TEXT_MAX_LENGTH = ITEM_MAX_LENGTH - 2 * HORIZONTAL_LINE_LENGTH - 2 * R.spacing.s;
//Vertical breadcrumb const
export const VERTICAL_LINE_WIDTH = 3;
//Common const
export const INDEX_INDICATOR_DIMENSION = 24;
